// 이용약관. 열린축산 주문앱(정육 포장/배달 주문, 현장결제+인앱 카드결제)의 서비스 이용 조건.
// 표준 전자상거래 약관을 매장 운영(현장수령/실중량 정산/현장·카드결제)에 맞게 구성. 법률 검토 후 확정 권장.

import LegalPageShell, { LegalSection } from "@/shared/LegalPageShell.tsx";
import { BUSINESS_INFO } from "@/shared/businessInfo.ts";

// 이용약관 본문(조항만). 전체 페이지와 가입 동의 모달에서 공용으로 쓴다.
export function TermsContent() {
  return (
    <>
      <LegalSection heading="제1조 (목적)">
        <p>
          본 약관은 {BUSINESS_INFO.name}(이하 "매장")이 운영하는 주문 서비스(이하 "서비스")를 이용함에
          있어 매장과 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.
        </p>
      </LegalSection>

      <LegalSection heading="제2조 (정의)">
        <p>"서비스"란 이용자가 매장의 상품(정육 등)을 포장 또는 배달로 주문할 수 있도록 제공되는 앱을 말합니다.</p>
        <p>"이용자"란 본 약관에 동의하고 서비스를 이용하는 회원 및 비회원을 말합니다.</p>
      </LegalSection>

      <LegalSection heading="제3조 (약관의 효력 및 변경)">
        <p>본 약관은 서비스 화면에 게시함으로써 효력이 발생합니다.</p>
        <p>
          매장은 관련 법령을 위반하지 않는 범위에서 약관을 개정할 수 있으며, 개정 시 적용일자와 사유를
          명시하여 사전 공지합니다.
        </p>
      </LegalSection>

      <LegalSection heading="제4조 (회원가입 및 탈퇴)">
        <p>이용자는 휴대폰 인증 또는 소셜 로그인을 통해 회원으로 가입할 수 있습니다.</p>
        <p>회원은 언제든지 탈퇴를 요청할 수 있으며, 매장은 관련 법령에 따른 보존 의무가 있는 경우를 제외하고 지체 없이 처리합니다.</p>
      </LegalSection>

      <LegalSection heading="제5조 (주문 및 결제)">
        <p>이용자는 상품을 선택해 포장 또는 배달로 주문할 수 있습니다.</p>
        <p>
          결제 수단은 매장 수령 시 현장 결제, 또는 앱 내 카드 결제(등록한 카드로 준비 완료 시 결제)를
          제공합니다. 배달 주문은 현장 결제 대신 SMS 결제요청을 이용할 수 있습니다.
        </p>
        <p>
          정육 상품은 실제 손질·계량에 따라 최종 중량이 달라질 수 있어, 최종 결제 금액은 준비 완료 시점에
          실제 중량을 반영하여 확정됩니다(주문 시 예상 금액의 ±10% 범위 내 변동 가능).
        </p>
      </LegalSection>

      <LegalSection heading="제6조 (청약철회 및 환불)">
        <p>
          주문 취소, 청약철회 제한(신선식품 특성), 교환·환불의 기준은 별도의 "취소·환불·교환 정책"에
          따릅니다.
        </p>
      </LegalSection>

      <LegalSection heading="제7조 (이용자의 의무)">
        <p>이용자는 주문 시 정확한 정보(수령 방법, 배송지, 연락처 등)를 제공해야 하며, 타인의 정보를 도용해서는 안 됩니다.</p>
      </LegalSection>

      <LegalSection heading="제8조 (매장의 의무 및 면책)">
        <p>매장은 안정적인 서비스 제공과 상품 품질 유지를 위해 노력합니다.</p>
        <p>
          천재지변, 통신 장애, 이용자의 귀책 등 매장의 책임 없는 사유로 발생한 손해에 대해서는 책임을 지지
          않습니다.
        </p>
      </LegalSection>

      <LegalSection heading="제9조 (개인정보보호)">
        <p>매장은 관련 법령에 따라 이용자의 개인정보를 보호하며, 자세한 내용은 "개인정보처리방침"에 따릅니다.</p>
      </LegalSection>

      <LegalSection heading="제10조 (분쟁해결 및 준거법)">
        <p>
          서비스 이용과 관련한 분쟁은 매장과 이용자가 성실히 협의하여 해결하며, 협의가 이루어지지 않을 경우
          관련 법령 및 관할 법원에 따릅니다.
        </p>
        <p>
          문의: {BUSINESS_INFO.tel} / {BUSINESS_INFO.email}
        </p>
      </LegalSection>
    </>
  );
}

// 이용약관 페이지(셸 + 본문).
export default function TermsPage() {
  return (
    <LegalPageShell title="이용약관" updatedAt="2026-06-22">
      <TermsContent />
    </LegalPageShell>
  );
}
